(function () {
  const ticker = document.querySelector('[data-password-news]');
  const track = ticker && ticker.querySelector('[data-password-news-track]');
  if (!ticker || !track) return;

  const endpoint = ticker.dataset.newsEndpoint;
  if (!endpoint) {
    ticker.dataset.newsState = 'fallback';
    return;
  }

  const restartTrack = (state) => {
    track.style.animation = 'none';
    void track.offsetWidth;
    ticker.dataset.newsState = state;
    requestAnimationFrame(() => track.style.removeProperty('animation'));
  };

  const sourceLabel = (url) => {
    try {
      const host = new URL(url).hostname.replace(/^www\./, '');
      if (host.endsWith('atptour.com')) return 'ATP TOUR';
      if (host.endsWith('wtatennis.com')) return 'WTA TOUR';
      return 'TOUR NEWS';
    } catch (_) {
      return 'TOUR NEWS';
    }
  };

  const makeItem = (item) => {
    const link = document.createElement('a');
    link.className = 'fg-password__ticker-item';
    link.href = item.u;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';

    const source = document.createElement('span');
    source.className = 'fg-password__ticker-source';
    source.textContent = item.tour || sourceLabel(item.u);

    const headline = document.createElement('span');
    headline.textContent = item.t;

    const arrow = document.createElement('span');
    arrow.className = 'fg-password__ticker-arrow';
    arrow.setAttribute('aria-hidden', 'true');
    arrow.textContent = '\u2197\uFE0E';

    link.append(source, headline, arrow);
    return link;
  };

  fetch(endpoint, { mode: 'cors', credentials: 'omit' })
    .then((response) => {
      if (!response.ok) throw new Error('News feed unavailable');
      return response.json();
    })
    .then((payload) => {
      const news = Array.isArray(payload.news)
        ? payload.news.filter((item) => item && item.t && item.u).slice(0, 6)
        : [];
      if (!news.length) {
        restartTrack('fallback');
        return;
      }

      const fragment = document.createDocumentFragment();
      for (let pass = 0; pass < 2; pass += 1) {
        const set = document.createElement('div');
        set.className = 'fg-password__ticker-set';
        if (pass === 1) set.setAttribute('aria-hidden', 'true');
        news.forEach((item) => set.appendChild(makeItem(item)));
        fragment.appendChild(set);
      }

      track.style.animation = 'none';
      track.replaceChildren(fragment);
      restartTrack('live');
    })
    .catch(() => restartTrack('fallback'));
})();
